'use strict';

const Conditions = {
  '': 'Siempre',
  prenda: 'Prenda',
  city: 'Localidad',
  agency: 'Agencia',
  creditor: 'Acreedor'
};

export default function ConditionController($scope, $mdDialog, services) {
  'ngInject';

  $scope.condition = '';
  $scope.ConditionLabels = Conditions;
  $scope.conditions = Object.keys(Conditions);

  $scope.queryAgencies = () => {
    return services.AgenciesService.find({
      where: {
        name: {
          ilike: `%${$scope.searchAgencyText}%`
        }
      }
    });
  };

  $scope.queryCreditors = () => {
    return services.CreditorsService.find({
      where: {
        name: {
          ilike: `%${$scope.searchCreditorText}%`
        }
      }
    });
  };

  $scope.onConditionChange = () => {};

  const getCondition = () => {
    const f = {
      prenda: () => {
        return {
          on: `operation.isPrenda == ${!!$scope.isPrenda}`,
          onLabel: ($scope.isPrenda ? '' : 'NO ') + 'Tiene prenda'
        };
      },
      city: () => {
        return {
          on: `operation.holder().legalAddress.cityId == ${
            $scope.cityData.cityId
          }`,
          onLabel: `Localidad es ${$scope.cityData.cityName} - ${
            $scope.cityData.provinceName
          }`
        };
      },
      agency: () => {
        return {
          on: `operation.agencyId == ${$scope.agency.id}`,
          onLabel: `Agencia es ${$scope.agency.name}`
        };
      },
      creditor: () => {
        return {
          on: `operation.isPrenda && operation.creditorId == ${
            $scope.creditor.id
          }`,
          onLabel: `Acreedor es ${$scope.creditor.name}`
        };
      },
      '': () => {}
    };
    return f[$scope.condition]();
  };

  $scope.save = () => {
    const condition = getCondition();
    $mdDialog.hide(condition);
  };
  $scope.cancel = () => {
    $mdDialog.cancel();
  };
}
